import React from 'react';
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";

import css from './PeriodsCreatePeriodModal.module.css';
import {periodsService} from "../../../../services/settings-services";
import {periodsActions} from "../../../../store/slices/settings-slices";


const PeriodsCreatePeriodModal = ({setIsOpen}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm();

    const submitHandler = async (data) => {
        try {
            await periodsService.createPeriod({
                "daysCount": Number(data.daysCount),
                "discount": Number(data.discount)
            });
            dispatch(periodsActions.changeTrigger());
            toast.success('fdfdfdgfd');
            setIsOpen(false);
        } catch (error) {
            console.error("Error creating group:", error);
            toast.error(t('modal-toast-creating-error'));
        }
    };


    return (
        <section className={css.modalOverlay}>
            <div className={css.modal}>
                <button className={css.closeButton} onClick={() => setIsOpen(false)}>
                    &times;
                </button>
                <h2 className={css.title}>{t('modal-periods-new-period')}</h2>
                <form onSubmit={handleSubmit(submitHandler)}>
                    <div className={css.inputGroup}>
                        <label htmlFor="daysCount">{t('modal-periods-days-count')}</label>
                        <input
                            type="number"
                            id="daysCount"
                            defaultValue={0}
                            {...register("daysCount", {required: "Days count is required"})}
                            className={errors.daysCount ? css.inputError : ""}
                        />
                        {errors.daysCount && (
                            <p className={css.error}>{errors.daysCount.message}</p>
                        )}
                    </div>

                    <div className={css.inputGroup}>
                        <label htmlFor="discount">{'Discount'}</label>
                        <input
                            type="number"
                            id="discount"
                            defaultValue={0}
                            {...register("discount", {required: "Discount is required"})}
                            className={errors.discount ? css.inputError : ""}
                        />
                        {errors.discount && (
                            <p className={css.error}>{errors.discount.message}</p>
                        )}
                    </div>
                    <button type="submit" className={css.submitButton}>
                        Ok
                    </button>
                </form>
            </div>
        </section>
    );
};

export {PeriodsCreatePeriodModal};